import "./SubscriptionOptions.css";
import React from "react";
import OptionCard from "./OptionCard";
import PropType from "prop-types";
import MembershipFeatureItem from "../MembershipFeatureItem";

export default function SubscriptionOptions(props) {
  return (
    <>
      <div className="membership-features">
        <>
          <MembershipFeatureItem
            feature="All written content across all of our sport offerings: PGA, NFL, CFB, & THE TRIPLE CROWN HORSE RACES"
            included={true}
          />
          <MembershipFeatureItem
            feature="Access to our Premium Member Private Chat on Slack"
            included={true}
          />
          <MembershipFeatureItem
            feature="All Bets from Gup including live bets and 2H picks released exclusively on Slack"
            included={true}
          />
          <MembershipFeatureItem
            feature="Premium Access to our Live Chats held on Wednesday for PGA and Sunday Morning for NFL"
            included={true}
          />
          <MembershipFeatureItem
            feature="Our education series of podcasts"
            included={true}
          />
          <MembershipFeatureItem
            feature="Access to PGA Tools: Research Center, Live Tournament, DFS Contest Sweat"
            included={props.label === "Full Site Membership"}
          />
          <MembershipFeatureItem
            feature="Access to Football Tools: NFL Stat Engine, NFL Matchup Advantage, NFL Redzone Advantage, NFL Scouting Report, NFL Projections"
            included={props.label === "Full Site Membership"}
          />
          <MembershipFeatureItem
            feature="Access to Green Machine Lineup Builder: GOLF, NFL, CFB, NHL, MLB, MMA, NASCAR, and TENNIS Slates"
            included={props.label === "Full Site Membership"}
          />
          <MembershipFeatureItem
            feature="PLUS, any future additions will be included at NO CHARGE"
            included={props.label === "Full Site Membership"}
          />
        </>
      </div>
      <div className="sub-options-container" label={props.label}>
        {props.prices.map((price) => {
          return (
            <OptionCard price={price} key={price.id} onClick={props.onClick} />
          );
        })}
      </div>
    </>
  );
}

SubscriptionOptions.propTypes = {
  label: PropType.string.isRequired,
  prices: PropType.arrayOf(PropType.node).isRequired,
  onClick: PropType.func.isRequired,
};
